export default __webpack_public_path__ + "static/media/LETTREmodif.5ce1d061.png";